export type Primitive = string | number;

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export const isDefinedValue = (v: unknown): v is Primitive => typeof v === 'string' || typeof v === 'number';
export const isObject = (v: unknown): v is Record<string, unknown> => typeof v === 'object' && v !== null;
export const hasResults = <T = unknown>(v: unknown): v is { results: T[] } => isObject(v) && Array.isArray(v.results);
export const hasData = <T = unknown>(v: unknown): v is { data: T[] } => isObject(v) && Array.isArray(v.data);
